import Vue from 'vue'
import Vuetify, { VTextField } from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '@mdi/font/css/materialdesignicons.css'
import { Ripple } from 'vuetify/lib/directives'
import VCurrencyField from 'v-currency-field'

Vue.use(Vuetify, {
  directives: {
    Ripple
  },
  iconfont: ['md', 'fa', 'mdi'],
  theme: {
    primary: '#1787c9',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    meChat: '#DCF8C6'
  },
  components: {
    VTextField
  }
})

Vue.use(VCurrencyField, {
  locale: 'es-AR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})
